/**
 * Table numbers are normally baked into each table's QR code as the `t` query
 * parameter. A bulk printing mistake left some cafes' QR codes all pointing at
 * `t=1` regardless of the actual table. We treat that value as "unknown table"
 * so checkout falls back to asking the customer to enter their table number,
 * until the affected prints are replaced.
 */
export const UNKNOWN_TABLE_QR_VALUE = "1";

export const getTableNumberFromUrl = () => {
  if (typeof window === "undefined") return "";
  try {
    const raw = (new URLSearchParams(window.location.search).get("t") || "").trim();
    if (raw && Number(raw) === Number(UNKNOWN_TABLE_QR_VALUE)) return "";
    return raw;
  } catch {
    return "";
  }
};
